import { Text, Tooltip } from '@timelyapp/react';
import classNames from 'classnames';
import ProjectBadge from 'components/projects/ProjectBadge';
import { Column, Item } from 'components/ui-blocks/placeholder';
import { range } from 'lodash-es';
import React, { Component } from 'react';
import type { SuggestedEntryProject } from 'types/timeline';
import { getProjectColor } from 'utils/project';
import styles from './ProjectSuggestions.module.scss';

interface ProjectSuggestionsProps {
  suggestions: Array<SuggestedEntryProject>;
  onChange: (projectId: number) => void;
  selectedProjectId?: number | null;
  size: 'medium' | 'large' | 'xlarge';
  /** Show placeholder suggestions, typically while loading */
  showPlaceholders: boolean;
  activeClass?: string;
  className?: string;
  /** How many suggestions to show? */
  count: number;
}

export class ProjectSuggestions extends Component<ProjectSuggestionsProps> {
  static defaultProps = {
    size: 'medium',
    showPlaceholders: false,
    count: 4,
  };

  renderPlaceholders = () => {
    const columns = range(3).map((key, i) => {
      return <Column key={i} span={12} className={styles.placeholderOption} />;
    });
    return <Item className={styles.placeholderContainer}>{columns}</Item>;
  };

  renderSuggestions = () => {
    const { count, onChange, selectedProjectId, activeClass } = this.props;
    const suggestions = this.props.suggestions.slice(0, count);

    return suggestions.map(project => {
      const { id: projectId, name, client, description } = project.base;
      const color = getProjectColor(project.base);
      const hasCustomActiveClass = activeClass
        ? { [activeClass]: selectedProjectId === projectId && activeClass }
        : {};
      return (
        <Tooltip
          usePortal
          key={projectId}
          className={styles.descriptionTooltip}
          position="right"
          fixed
          tooltip={
            description ? (
              <Text as="div" className="fs-mask" size="xsmall" ellipsis={6}>
                {description}
              </Text>
            ) : null
          }
        >
          <button
            data-testid="project_suggestion"
            className={classNames(styles.projectOption, this.props.className, {
              [styles.isActive]: selectedProjectId === projectId,
              ...hasCustomActiveClass,
            })}
            type="button"
            onClick={() => onChange(projectId)}
          >
            <ProjectBadge
              color={`#${color}`}
              className={styles.bullet}
              size="small"
              ticMeta={project.base.tic}
            />
            <div className={styles.nameAndClient}>
              <span className="fs-mask">{name}</span>
              <small className="fs-mask">({client.name})</small>
            </div>
          </button>
        </Tooltip>
      );
    });
  };

  render() {
    const { showPlaceholders, size } = this.props;
    return (
      <div className={classNames(styles.container, this.props.className, styles[`size-${size}`])}>
        {showPlaceholders ? this.renderPlaceholders() : this.renderSuggestions()}
      </div>
    );
  }
}
